export default {
  logo: {
    title: 'Mambrino',
    anchor: {
      href: '/'
    }
  },
  nav: {
    items: []
  }
};
